<template>
  <div id="app">
    <!-- 公共头部 -->
    <AppHeader @show-popup="showPopup = true" />
    
    <!-- 路由视图 -->
    <router-view @show-popup="showPopup = true" />
    
    <!-- 申请试用 -->
    <ApplySection ref="applySection" />

    <!-- 公共页脚 -->
    <AppFooter />

    <!-- 全局提示（$toast）挂载点 -->
    <ToastHost />
    
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import ApplySection from '@/components/ApplySection.vue'
import ToastHost from '@/components/ToastHost.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    ApplySection,
    ToastHost
  },
  data() {
    return {
      showPopup: false
    }
  },
  mounted() {
    // 检查是否需要打开申请弹窗
    if (this.$route.query.openApply === 'true') {
      this.showPopup = true
    }
  },
  watch: {
    // 监听路由变化，检查是否打开申请弹窗（页面标题由路由守卫统一设置）
    '$route'(to) {
      if (to.query.openApply === 'true') {
        this.showPopup = true
      }
    }
  }
}
</script>

<!--
  全局样式（reset / .container / section 间距 / 通用标题按钮 / 滚动动画）已迁至
  src/styles/base.css，设计变量在 src/styles/tokens.css，两者都由 src/main.js 引入。
  组件内不要再写全局规则。
-->


// WEBPACK FOOTER //
// src/App.vue